
export const hasChars = (inp: any) => {
    const inputAsString = `${inp}`;
    return inputAsString && inputAsString.length > 0;
};
